<template>

    <div class="list-row" :style="{height:cellheight+'px'}">
        <!-- <div class="row-title">{{row.spw.Sub_Project_Work_Name_SPW}}</div>  -->
        <v-lazy height="40" :options="{rootMargin:'100px'}">   
        <div v-if="defer(1)">
                <div class="row-wrap">
                    <div class="d-flex align-center" style="border-right: solid 1px #cccccc" v-on:click="selectSPW">
                    <v-btn  icon class="ma-0 px-4" width="20">
                        <v-icon small class="ma-0 pa-0" width="20">launch</v-icon>
                    </v-btn>
                    </div>
                <div class="color-indicator" :style="{backgroundColor:rowColor}"></div>



                <div class="select-container" >
                    <v-autocomplete
                            v-if="defer(2)"
                            v-model="row.spw.Foreman_SPW"
                            :items="users"
                            color="white"
                            hide-selected
                            item-text="Name_Concatenate"
                            item-value="ID"
                            hide-details
                            return-object
                            solo
                            dense
                            class="ma-0 pa-0"
                            label="Select Foreman"
                            elevation="0"
                    > 
                    </v-autocomplete>
                </div> 

                

                           <!-- <div class="select-container">
                    <LazyAutoComplete
                            v-model="row.spw.Foreman_SPW"
                            :items="users"
                            :itemtext="'Name_Concatenate'"
                            :itemvalue="'ID'"
                            :label="'Select Foreman'"
                    > 
                    </LazyAutoComplete>
                </div>
            -->
                 <div class="select-container">
                    <v-autocomplete
                            v-if="defer(2)"
                            v-model="row.spw.Department_in_Charge_SPW"
                            :items="departments"
                            color="white"
                            hide-selected
                            item-text="Department_Name"
                            item-value="ID"
                            hide-details
                            return-object
                            solo
                            dense
                            class="ma-0 pa-0"
                            label="Select Department"
                            elevation="0"
                    > 
                    </v-autocomplete>
                </div>

            <!-- <div class="select-container">
                    <LazyAutoComplete
                            v-model="row.spw.Department_in_Charge_SPW"
                            :items="departments"
                            :itemtext="'Department_Name'"
                            :itemvalue="'ID'"
                            :label="'Select Department'"
                    > 
                    </LazyAutoComplete>
                </div>
                 -->

                
                <!-- <div class="select-container">
                <LazySelect :model="row.spw.Foreman_SPW" :items="users" :itemtext="'Name_Concatenate'" :itemvalue="'ID'" :label="'Select Foreman'"></LazySelect>
                </div>


                <div class="select-container">
                <LazySelect :model="row.spw.Department_in_Charge_SPW" :items="departments" :itemtext="'Department_Name'" :itemvalue="'ID'" :label="'Select Department'"></LazySelect>
                </div> -->
                <div class="select-container date-select" v-if="defer(2)">
                <DateSelect :bindTo="row_spw.Start_Date_SPW" :callback="updateStartDate" solo :label="'Start Date'"></DateSelect>
                </div>
              
                <div class="select-container date-select" v-if="defer(2)">
                <DateSelect :bindTo="row_spw.End_Date_SPW" :callback="updateEndDate" solo :label="'End Date'"></DateSelect>
                </div>

                    <div class="select-container select-medium" v-if="defer(2)">
                    <v-autocomplete
                            v-model="row.spw.Schedule_SPW"
                            :items="['Not Started','In Progress','Ready to Review','Complete']"
                            :label="'Status'"
                            solo
                            dense
                            hide-details=""
                    > 
                    </v-autocomplete>
                </div>
                
                <v-col cols="auto" class="pa-0 ma-0" v-if="show_labels">
                      <v-combobox
     
        outlined   
        v-model="row.spw.schedule_labels"
        :items="allLabels"
        dense
        multiple
        small-chips
        return-object
        v-on:click.stop
        v-on:focus.prevent
        hide-details
        deletable-chips
        class="rounded-0 labelscontainer"
        style="min-width:60px"

        >
        <template v-slot:selection="data">
            <v-chip
            x-small label
            style="px-0 mx-0"
              :key="JSON.stringify(data.item)"
              v-bind="data.attrs"
              :input-value="data.selected"
              :disabled="data.disabled"
              @click:close="data.parent.selectItem(data.item)"
            >
    
              {{ data.item }}
            </v-chip>
          </template>

         <template v-slot:item="{  item }">
            <v-chip x-small label>{{item}}</v-chip>
          </template>


        </v-combobox>
</v-col>
                <div v-if="!row_spw.Start_Date_SPW" style="display:flex; align-items:center;" class="ml-2">
                    <v-chip  color="red" style="white-space:nowrap;" label x-small dark>Unscheduled</v-chip>
                </div>
                
                <div class="row-description caption" v-on:click="selectSPW">
                    
                    {{row.spw.Sub_Project_Work_Name_SPW}}</div>
                </div>
            
        </div>
        
        </v-lazy> 
        
    </div>
 
</template>

<script>
import { mapState } from 'vuex';
import { mapGetters } from 'vuex'
// import { mapActions } from 'vuex'
// import { mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields';
import DateSelect from './DateSelect';
// import LazyAutoComplete from './LazyAutoComplete';
import Defer from '@/mixins/Defer'

  export default {
    name: 'Row',
    props: ['row'],
    components: {
        DateSelect,
        // LazySelect
        // LazyAutoComplete
    },
    mixins: [
        Defer()
    ],
    data: () => ({
        start_menu: false
    }),
    computed: {
      ...mapState(['users','departments','colors','cellheight','show_labels']),
      ...mapFields(['subproject_works','selection']),
      ...mapGetters(['allLabels']),
      row_spw(){
          return this.subproject_works.find(r=>{return r.ID == this.row.spw.ID})
      },
        rowColor(){
            if (this.row.spw.Foreman_SPW.ID){
          return this.colors[this.row.spw.Foreman_SPW.ID]
            }
            else{
                return this.colors[0]
            }
      }
    },
    methods: {
    updateStartDate(evt){
      
          this.row_spw.Start_Date_SPW = evt
      },
      updateEndDate(evt){
          this.row_spw.End_Date_SPW = evt
      },
      selectSPW(){
          this.selection = this.row_spw
      }
    }
  }
</script>

<style>
.row-title{
    border-bottom: solid 1px #cccccc;
    border-top: solid 1px #cccccc;
    background-color:#efefef;
    height: 20px;
    display: flex;
    align-items: center;
    font-size: .6em;
    box-sizing: border-box;
    white-space:nowrap;
    padding: 5px;
}
.list-row{
    border-bottom: solid 1px #cccccc;
    box-sizing: border-box;
    border-bottom: solid 1px #cccccc;
}
.row-wrap{
    display:flex;
    align-items: stretch;
}
.select-container{
    min-width: 140px;
        display: flex;
    align-items: stretch;
}
.select-medium{
    min-width: 120px;
    max-width:120px;
}
.date-select{
    width:80px;
    min-width: 80px;
}
.row-description{
    display: flex;
   flex:1;
    white-space:nowrap;
    overflow:hidden;
    text-overflow: ellipsis;
        align-items: center;
        padding-left: 10px;
        cursor:pointer;

}
.list-row .v-input{
    border-radius: 0px !important;
}
.list-row .v-input__slot{
    border-radius: 0px !important;
    box-shadow:none !important;
    border-right: solid 1px #dfdfdf;
}

.list-row .v-select__selection, .list-row .v-label, .list-row .v-text-field__slot, .list-row .v-select__slot{
    font-size:.8em !important;
}
.list-row .v-input__slot{
    height: 39px;
    box-sizing: border-box;
    padding-left: 8px !important;
    margin-left: 0px !important;
}
.list-row fieldset{
    border: none !important;
    border-bottom: solid 1px #cccccc !important;
}
.list-row .v-label{
    color:#F44336;

}
.list-row .v-select__slot input{
    font-size: .9em;
    font-weight:bold;
}

.list-row .custom-date-selector label{
    display: block;
    text-align: center;
    width:100%;
    max-width: 100% !important;
}
.list-row .custom-date-selector input{
    font-size:.9em;
    text-align: center;
}
.color-indicator{
    width: 10px;
    margin: 5px;
    border-radius: 2px;
    margin-right: 0px;

}
.list-row .v-input__icon i{
    margin-right: 0px;
}
.list-row .v-input__icon{
    min-width: 0px;
    width: 10px;
}

.labelscontainer .v-select__selections input { 
    width: 10px;
}
  
</style>
